import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationStateDownloadUrlArgs, StateDownloadUrl } from "types/generated";

type StateDownloadUrlData = {
  stateDownloadUrl: Pick<StateDownloadUrl, "url">;
};

export const STATE_DOWNLOAD_URL: TypedDocumentNode<
  StateDownloadUrlData,
  MutationStateDownloadUrlArgs
> = gql`
  mutation StateDownloadUrl($input: StateDownloadUrlInput!) {
    stateDownloadUrl(input: $input) {
      url
    }
  }
`;
